<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path d="M22.326 12c0-5.703-4.623-10.326-10.326-10.326S1.674 6.297 1.674 12 6.297 22.326 12 22.326 22.326 17.703 22.326 12M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12"/>
  <path d="M15.848 8.085a.837.837 0 0 1 1.234 1.132l-6.14 6.698a.837.837 0 0 1-1.208.026l-2.791-2.79a.837.837 0 1 1 1.184-1.185l2.171 2.172z"/>
</svg>
